var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "info" }, [
      _c("i", { staticClass: "icon icon-audit-touxiang66dark" }),
      _vm.hiddenRemove
        ? _c(
            "span",
            { staticClass: "size", on: { click: _vm.handleClickRemove } },
            [_vm._v("×")]
          )
        : _vm._e()
    ]),
    _vm.hiddenArrow
      ? _c("div", { staticClass: "arrow" }, [
          _c("i", { staticClass: "icon icon-audit-jiantou32" })
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "slot" },
      [_vm._t("username"), _vm._t("update")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1847a8a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1847a8a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/flow/index.vue
// module id = +040
// module chunks = 2 3 6 7 8 15 16 18 19 20 21 22 30 33 35 36 44 45 46 56 100 101 102 108 109